export default __webpack_public_path__ + "static/media/debt.03322e90.png";